import { axios } from '@/libraries/axios'
import { call } from '@/libraries/api'

interface Profile {
  picture?: string
}

export function endpoint() {
  return call(() => axios.get<Profile>('/api/oauth/endpoint'), null)
}

export function login(body: { email?: string; remember?: boolean }) {
  return call(() => axios.post<{ redirect?: string }>('/api/auth?response=json', body), null)
}

export function logout() {
  return call(() => axios.get<{ success?: boolean }>('/api/oauth/logout?response=json'), null)
}
